import React from 'react'
import { Building } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export const Warehouses: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Warehouse Management</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">Manage warehouse locations and inventory distribution</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Building className="w-5 h-5" />Warehouse Locations
          </CardTitle>
          <CardDescription>Storage facilities and distribution centers</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <Building className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">Warehouse System</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">Multi-location inventory management</p>
            <Button variant="outline">Manage Locations</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
